module.exports = __webpack_public_path__ + "img/icon-signout.c53c5899.svg";